import React from "react";
import {Map} from "immutable";

export default class WithRecords extends React.Component {
  constructor(props) {
    super(props);
    this.pagination = 10;
    const {store, defaultQuery, defaultPage} = this.props;
    // Initially return what we know from state, unless a deafaultQuery
    // is given in which return and empty List until query is executed.
    const initialResources = defaultQuery
      ? Map()
      : store.slice(defaultPage * this.pagination - this.pagination, Math.min(store.size, this.pagination));
    this.state = {
      fetching: false,
      initialized: false,
      currentPage: defaultPage,
      currentQuery: defaultQuery,
      filterQuery: {},
      total: initialResources.size,
      resources: initialResources
    };
  }

  componentDidMount = () => {
    this.goToPage();
  };

  onQueryChange = change => {
    return new Promise(resolve => {
      this.setState(
        {
          currentQuery: {
            ...this.state.currentQuery,
            ...change
          }
        },
        newState => resolve(newState)
      );
    });
  };

  onSearchSubmit = () => {
    return this.goToPage(1);
  };

  onSort = async sortQuery => {
    await this.onQueryChange({$sort: sortQuery});
    return this.goToPage();
  };

  onFilter = async filterQuery => {
    await new Promise(resolve => {
      this.setState({filterQuery}, newState => resolve(newState));
    });
    return this.goToPage();
  };

  goToPage = async (
    pageNumber = this.state.currentPage,
    _query = this.state.currentQuery,
    _filterQuery = this.state.filterQuery
  ) => {
    if (_filterQuery === "zero") {
      return this.setState({
        fetching: false,
        initialized: true,
        currentPage: pageNumber,
        currentQuery: _query,
        total: 0,
        resources: new Map()
      });
    }
    const query = {..._query, $page: pageNumber};
    return this.props.record.find({query: {...query, ..._filterQuery}}).then(({data: resources, total}) => {
      this.setState({
        fetching: false,
        initialized: true,
        currentPage: pageNumber,
        currentQuery: query,
        total,
        resources
      });
    });
  };

  render() {
    return this.props.render({
      ...this.state,
      goToPage: this.goToPage,
      pagination: this.pagination,
      onQueryChange: this.onQueryChange,
      onSearchSubmit: this.onSearchSubmit,
      onSort: this.onSort,
      onFilter: this.onFilter
    });
  }
}

WithRecords.defaultProps = {
  defaultPage: 1,
  defaultQuery: undefined
};



// WEBPACK FOOTER //
// ./src/components/WithRecords/index.jsx